module.exports = __webpack_public_path__ + "static/media/apple-store-icon.d02382d0.png";